import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import DashboardAnalytics from "../pages/DashboardAnalytics";
import DashboardCrm from "../pages/DashboardCrm";
import DashboardEcommerce from "../pages/DashboardEcommerce";

import DashboardCrypto from "../pages/DashboardCrypto";
import DashboardProject from "../pages/DashboardProject";
import DashboardNFT from "../pages/DashboardNFT";
import DashboardJob from "../pages/DashboardJob/";
import Home from "../pages/Home";
import WorkflowsLauncher from "../pages/WorkflowsLauncher";

//Accounting //Eng. //HR //IT // Planning // Production // Quality // Sales // Shipping //Shukla Medical // Supervisor // KPIs //DI //MAFIA //DisplayBoards

import Accounting from "../pages/Accounting/index";
import Perflexion from "../pages/Perflexion";
import Engineering from "../pages/Engineering/index";
import HumanResource from "../pages/HumanResource/index";
import InfoTechnology from "../pages/IT/index";
import Planning from "../pages/Planning/index";
import Production from "../pages/Production/index";
import Quality from "../pages/Quality/index";
import Sales from "../pages/Sales/index";
import Shipping from "../pages/Shipping/index";
import Shukla from "../pages/Shukla/index";
import Supervisor from "../pages/Supervisor/index";
import KPI from "../pages/KPI/index";
import XRayReport from "../pages/KPI/XRayReport";
import XRayRouteGuard from "../pages/KPI/XRayRouteGuard";
import KpiHubRouteGuard from "../pages/KPI/KpiHubRouteGuard";
import OtdReport from "../pages/KPI/OtdReport";
import PlanningRouteGuard from "../pages/KPI/PlanningRouteGuard";
import UnifiedReviewPage from "../pages/HumanResource/UnifiedReviewPage.js";

import ManageDepartments from "../pages/HumanResource/ManageDepartments.js";
import ManageRoles from "../pages/HumanResource/ManageRoles.js";
import HrDashboard from "../pages/HumanResource/HrDashboard.js";       // Phase 3 / Feature 2
import MyProfile from "../pages/Profile/MyProfile.js";                  // Phase 3 / Feature 3
// ── Round: HR UI Simplification (Phase 1) ────────────────────────────────
// The deep HR pages (EmpReactivate, ProfileUpdateApprovals, AuditTrail,
// FtoYearEnd, AddPaidFto, FtoHrSummary, CompensationDays, FtoHolidays,
// YearEndRequestView, HrReviewDashboard, CoaCentral, LateInReview,
// AttendanceReport, LateInReport, AttendanceAnalytics, PayrollTimeCard,
// AddFtoHr, LeaveArchive, RecordAbsence) are no longer imported HERE:
// their old routes below now redirect into the canonical HR shell
// (/humanresource?section=…), which lazy-loads the SAME components via
// React.lazy (see src/pages/HumanResource/shell/*). Each redirect keeps
// its original RoleProtected wrapper at the old URL, so direct
// unauthorized hits are denied exactly as before. /hr/dashboard,
// /hr/departments, /hr/roles and /attendance/approvals are unchanged.
import DocumentManagementSystem from "../pages/DocumentManagementSystem/Index.js";
import ApprovalPage from "../pages/DocumentManagementSystem/ECN/ApprovalPage.js";
import AllDocuments from "../pages/DocumentManagementSystem/AllDocuments.js";
import Data from "../pages/DocumentManagementSystem/Data.js";
import CreateEcn from "../pages/DocumentManagementSystem/ECN/CreateEcn.js";
import CreateSop from "../pages/DocumentManagementSystem/ECN/CreateEcn.js";
import CreateWi from "../pages/DocumentManagementSystem/ECN/CreateEcn.js";
import CreateFcd from "../pages/DocumentManagementSystem/ECN/CreateEcn.js";
import CreateLit from "../pages/DocumentManagementSystem/ECN/CreateEcn.js";

import AttendanceIndex from "../pages/Personal Attendance/index.js";
import FtoRequestPage from "../pages/Personal Attendance/FtoRequestPage.js";
import ApprovalsPage from "../pages/Personal Attendance/ApprovalsPage.js";

import DI from "../pages/DI/index";
// Batch 3 / Round 15 — DI Simulator (legacy Simselect.vb, the "-j"
// engineer mode): read-only MAFIA-table preview, open to all employees
// per the audit decision (same app.di gate as /di).
import DISimulator from "../pages/DI/Inspection/SimSelect";
import DIAuditLog from "../pages/DI/AuditLog";

// IT Admin
import EmployeeRoleAssignment from "../pages/Admin/EmployeeRoleAssignment";
import EmployeeEpoLimitAssignment from "../pages/Admin/EmployeeEpoLimitAssignment";
import UserPermissionsPage from "../pages/Admin/UserPermissionsPage";
import AdminHub from "../pages/Admin/AdminHub";
import AccessManagement from "../pages/Admin/AccessManagement";
import AccessDenied from "../pages/AccessDenied";
import RoleProtected from "../Components/Common/RoleProtected";

// Phase 2.3b — DMS inbox pages
import MyTraining from "../pages/DocumentManagementSystem/Inbox/MyTraining";
// Round R1 — Restore dedicated DMS inbox pages (legacy menu parity:
//   "Documents Ready for Release" → DMSAwaiting releaser mode
//   "Documents Awaiting my Approval" → DMSAwaiting default mode)
import AwaitingRelease from "../pages/DocumentManagementSystem/Inbox/AwaitingRelease";
import MyPendingApprovals from "../pages/DocumentManagementSystem/Inbox/MyPendingApprovals";
// Round R12 (2026) — Save Draft (Q11) + email-link landing page.
import MyDrafts from "../pages/DocumentManagementSystem/Inbox/MyDrafts";
import TokenAction from "../pages/DocumentManagementSystem/Approval/TokenAction";



import Mafia from "../pages/Mafia/MenuPage.js";
import DisplayBoards from "../pages/DisplayBoards/index";
import EPO from "../pages/ExpensePurchaseOrder/index";
import EpoApprovalsTimeLine from "../pages/ExpensePurchaseOrder/EpoApprovalTimeline.js";

// Phase 3 Pass 2 — manager-menu EPO screens (per legacy menus):
//   "MPC EPO Viewer"               → /epo/mpc-viewer        role-based
//   "EPOs Not Ready For Payment"   → /epo/not-ready         every user
//   "Find EPO by Number"           → /epo/find              manager+
import MpcEpoViewer from "../pages/ExpensePurchaseOrder/MpcEpoViewer.js";
import EposNotReadyForPayment from "../pages/ExpensePurchaseOrder/EposNotReadyForPayment.js";
import FindEpoByNumber from "../pages/ExpensePurchaseOrder/FindEpoByNumber.js";
import SubordinateEpos from "../pages/ExpensePurchaseOrder/SubordinateEpos.js";
import EposReadyForPayment from "../pages/ExpensePurchaseOrder/EposReadyForPayment.js";
import EposShipping from "../pages/ExpensePurchaseOrder/EposShipping.js";
import EposReceive from "../pages/ExpensePurchaseOrder/EposReceive.js";  // R16
// Batch 3 / Round 7 — line-item search (Shipping/Find aid).
import EpoLineSearch from "../pages/ExpensePurchaseOrder/EpoLineSearch.js";
// Batch 3 / Round 8 — No-EPO / Missing-EPO shipment tracker.
import MissingEpoDashboard from "../pages/ExpensePurchaseOrder/MissingEpoDashboard.js";
import EpoPartialPayments from "../pages/ExpensePurchaseOrder/EpoPartialPayments.js";  // R19
import EpoApprovalsInbox from "../pages/ExpensePurchaseOrder/EpoApprovalsInbox.js";

// Phase 3 Pass 2 — manager-menu Project Approval screens:
//   "View My Department's Projects"  → /projects/my-department
//   "View Projects Awaiting Approval"→ /projects/awaiting-approval
import DeptProjects from "../pages/ProjectApproval/DeptProjects.js";
import ProjectsAwaitingApproval from "../pages/ProjectApproval/AwaitingApproval.js";

// Phase 3 Pass 3 — manager-menu FTO/COA, Tasks, Travel Expense.
//   /attendance/dept/fto[?future=1]   "Show All / Future FTOs of my Dept"
//   /attendance/dept/coa[?future=1]   "Show All / Future COAs of my Dept"
//   /attendance/ytd                   "Review YTD FTO Status"
//   /attendance/fto/schedule          "Show My FTO Schedule"
//   /attendance/coa/schedule          "Show My COA Schedule"
//   /task-management/dept             "View My Department's Tasks"
//   /task-management/by-date          "View My Task Reporting By Date"
//   /task-management/assigned         "View Tasks I've Assigned"
//   /travel-expense                   "Travel Expense Approval"
//   /travel-expense/:id               Trip detail + approve/reject
import DeptFtos            from "../pages/Personal Attendance/DeptFtos.js";
import DeptCoas            from "../pages/Personal Attendance/DeptCoas.js";
import YtdFtoReport        from "../pages/Personal Attendance/YtdFtoReport.js";
import MyFtoBalance        from "../pages/Personal Attendance/MyFtoBalance.js";  // G-37 (P8)
import { FtoSchedule, CoaSchedule } from "../pages/Personal Attendance/MyAttendanceSchedule.js";
import DeptTasks from "../pages/TaskManagement/DeptTasks.js";
import TaskReportingByDate from "../pages/TaskManagement/TaskReportingByDate.js";
import TasksIveAssigned from "../pages/TaskManagement/TasksIveAssigned.js";
// Rounds TM-7/9/13 (2026) — legacy screens restored.
import EndOfDay from "../pages/TaskManagement/EndOfDay.js";
import CurrentDeptActivity from "../pages/TaskManagement/CurrentDeptActivity.js";
import TaskAuditor from "../pages/TaskManagement/TaskAuditor.js";
import TravelExpenseIndex from "../pages/TravelExpense/index.js";
import TravelExpenseDetail from "../pages/TravelExpense/TravelExpenseDetail.js";
import TravelExpenseForm from "../pages/TravelExpense/TravelExpenseForm.js";

import OrgChart from "../pages/OrganizationalChart/orgChart.js";
import TaskManagement from "../pages/TaskManagement/index.js";
import CreateTask from "../pages/TaskManagement/CreateTask/index.js";
import TaskDetail from "../pages/TaskManagement/TaskDetails/index.js";

// ── Merged from development branch ─────────────────────────────────────────
// Time & Attendance employee tools: PunchRecord (legacy punch history),
// WhosInBuilding (live presence), and a unified SchedulePage (FTO+COA combined
// month grid). Visitors page is the modern equivalent of the legacy
// Expected Visitors register.
import PunchRecord from "../pages/DashboardCrypto/PunchRecord.js";
import WhosInBuilding from "../pages/DashboardCrypto/WhosInBuilding.js";
import SchedulePage from "../pages/Personal Attendance/SchedulePage.js";
import ExpectedVisitors from "../pages/Visitors/index.js";
// Support module (Freshdesk) — read-write support tickets for SSW + Shukla.
import Support from "../pages/Support/index.js";

// ── Added during merge reconciliation ──────────────────────────────────────
// SN-PO Awaiting FL Approval — was deferred in earlier passes but the user
// asked for full legacy parity. Backend: Controllers/EPO/SnEpoController.cs.
import SnEpoAwaitingFlApproval from "../pages/ExpensePurchaseOrder/SnEpoAwaitingFlApproval.js";

// Contract Review (Pass 3 + Pass 4)
import ContractReview from "../pages/ContractReview/index";
import ContractReviewForm from "../pages/ContractReview/ContractReviewForm";

//Accounting //Eng. //HR //IT // Planning // Production // Quality // Sales // Shipping //Shukla Medical // Supervisor // KPIs //DI //MAFIA //DisplayBoards

//Calendar
// Email box
import MailInbox from "../pages/EmailInbox";
import BasicAction from "../pages/Email/EmailTemplates/BasicAction";
import EcommerceAction from "../pages/Email/EmailTemplates/EcommerceAction";

//Chat
import Chat from "../pages/Chat";
import Calendar from "../pages/Calendar";

// Project
import ProjectList from "../pages/Projects/ProjectList";
import ProjectOverview from "../pages/Projects/ProjectOverview";
import CreateProject from "../pages/Projects/CreateProject";

//Task
import TaskDetails from "../pages/Tasks/TaskDetails";
import TaskList from "../pages/Tasks/TaskList";

//Transactions
import Transactions from "../pages/Crypto/Transactions";
import BuySell from "../pages/Crypto/BuySell";
import CryproOrder from "../pages/Crypto/CryptoOrder";
import MyWallet from "../pages/Crypto/MyWallet";
import ICOList from "../pages/Crypto/ICOList";
import KYCVerification from "../pages/Crypto/KYCVerification";

//Crm Pages
import CrmCompanies from "../pages/Crm/CrmCompanies";
import CrmContacts from "../pages/Crm/CrmContacts";
import CrmDeals from "../pages/Crm/CrmDeals/index";
import CrmLeads from "../pages/Crm/CrmLeads/index";

//Invoices
import InvoiceList from "../pages/Invoices/InvoiceList";
import InvoiceCreate from "../pages/Invoices/InvoiceCreate";
import InvoiceDetails from "../pages/Invoices/InvoiceDetails";

// Support Tickets
import ListView from "../pages/SupportTickets/ListView";
import TicketsDetails from "../pages/SupportTickets/TicketsDetails";

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceProducts/EcommerceAddProduct";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceOrderDetail from "../pages/Ecommerce/EcommerceOrders/EcommerceOrderDetail";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceSellers from "../pages/Ecommerce/EcommerceSellers/index";
import EcommerceSellerDetail from "../pages/Ecommerce/EcommerceSellers/EcommerceSellerDetail";

// NFT Marketplace Pages
import Marketplace from "../pages/NFTMarketplace/Marketplace";
import Collections from "../pages/NFTMarketplace/Collections";
import CreateNFT from "../pages/NFTMarketplace/CreateNFT";
import Creators from "../pages/NFTMarketplace/Creators";
import ExploreNow from "../pages/NFTMarketplace/ExploreNow";
import ItemDetails from "../pages/NFTMarketplace/Itemdetails";
import LiveAuction from "../pages/NFTMarketplace/LiveAuction";
import Ranking from "../pages/NFTMarketplace/Ranking";
import WalletConnect from "../pages/NFTMarketplace/WalletConnect";

// Base Ui
import UiAlerts from "../pages/BaseUi/UiAlerts/UiAlerts";
import UiBadges from "../pages/BaseUi/UiBadges/UiBadges";
import UiButtons from "../pages/BaseUi/UiButtons/UiButtons";
import UiColors from "../pages/BaseUi/UiColors/UiColors";
import UiCards from "../pages/BaseUi/UiCards/UiCards";
import UiCarousel from "../pages/BaseUi/UiCarousel/UiCarousel";
import UiDropdowns from "../pages/BaseUi/UiDropdowns/UiDropdowns";
import UiGrid from "../pages/BaseUi/UiGrid/UiGrid";
import UiImages from "../pages/BaseUi/UiImages/UiImages";
import UiTabs from "../pages/BaseUi/UiTabs/UiTabs";
import UiAccordions from "../pages/BaseUi/UiAccordion&Collapse/UiAccordion&Collapse";
import UiModals from "../pages/BaseUi/UiModals/UiModals";
import UiOffcanvas from "../pages/BaseUi/UiOffcanvas/UiOffcanvas";
import UiPlaceholders from "../pages/BaseUi/UiPlaceholders/UiPlaceholders";
import UiProgress from "../pages/BaseUi/UiProgress/UiProgress";
import UiNotifications from "../pages/BaseUi/UiNotifications/UiNotifications";
import UiMediaobject from "../pages/BaseUi/UiMediaobject/UiMediaobject";
import UiEmbedVideo from "../pages/BaseUi/UiEmbedVideo/UiEmbedVideo";
import UiTypography from "../pages/BaseUi/UiTypography/UiTypography";
import UiList from "../pages/BaseUi/UiLists/UiLists";
import UiGeneral from "../pages/BaseUi/UiGeneral/UiGeneral";
import UiRibbons from "../pages/BaseUi/UiRibbons/UiRibbons";
import UiUtilities from "../pages/BaseUi/UiUtilities/UiUtilities";

// Advance Ui
import UiNestableList from "../pages/AdvanceUi/UiNestableList/UiNestableList";
import UiScrollbar from "../pages/AdvanceUi/UiScrollbar/UiScrollbar";
import UiAnimation from "../pages/AdvanceUi/UiAnimation/UiAnimation";
import UiTour from "../pages/AdvanceUi/UiTour/UiTour";
import UiSwiperSlider from "../pages/AdvanceUi/UiSwiperSlider/UiSwiperSlider";
import UiRatings from "../pages/AdvanceUi/UiRatings/UiRatings";
import UiHighlight from "../pages/AdvanceUi/UiHighlight/UiHighlight";

// Widgets
import Widgets from "../pages/Widgets/Index";

//Forms
import BasicElements from "../pages/Forms/BasicElements/BasicElements";
import FormSelect from "../pages/Forms/FormSelect/FormSelect";
import FormEditor from "../pages/Forms/FormEditor/FormEditor";
import CheckBoxAndRadio from "../pages/Forms/CheckboxAndRadio/CheckBoxAndRadio";
import Masks from "../pages/Forms/Masks/Masks";
import FileUpload from "../pages/Forms/FileUpload/FileUpload";
import FormPickers from "../pages/Forms/FormPickers/FormPickers";
import FormRangeSlider from "../pages/Forms/FormRangeSlider/FormRangeSlider";
import Formlayouts from "../pages/Forms/FormLayouts/Formlayouts";
import FormValidation from "../pages/Forms/FormValidation/FormValidation";
import FormWizard from "../pages/Forms/FormWizard/FormWizard";
import FormAdvanced from "../pages/Forms/FormAdvanced/FormAdvanced";
import Select2 from "../pages/Forms/Select2/Select2";

//Tables
import BasicTables from "../pages/Tables/BasicTables/BasicTables";
import GridTables from "../pages/Tables/GridTables/GridTables";
import ListTables from "../pages/Tables/ListTables/ListTables";
import DataTables from "../pages/Tables/DataTables/DataTables";
import ReactTable from "../pages/Tables/ReactTables";

//Icon pages
import RemixIcons from "../pages/Icons/RemixIcons/RemixIcons";
import BoxIcons from "../pages/Icons/BoxIcons/BoxIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign/MaterialDesign";
import FeatherIcons from "../pages/Icons/FeatherIcons/FeatherIcons";
import LineAwesomeIcons from "../pages/Icons/LineAwesomeIcons/LineAwesomeIcons";
import CryptoIcons from "../pages/Icons/CryptoIcons/CryptoIcons";

//Maps
import GoogleMaps from "../pages/Maps/GoogleMaps/GoogleMaps";
import VectorMaps from "../pages/Maps/VectorMaps/VectorMaps";
import LeafletMaps from "../pages/Maps/LeafletMaps/LeafletMaps";

//AuthenticationInner pages
import BasicSignIn from "../pages/AuthenticationInner/Login/BasicSignIn";
import CoverSignIn from "../pages/AuthenticationInner/Login/CoverSignIn";
import BasicSignUp from "../pages/AuthenticationInner/Register/BasicSignUp";
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from "../pages/AuthenticationInner/PasswordReset/BasicPasswReset";
//pages
import Starter from "../pages/Pages/Starter/Starter";
import SimplePage from "../pages/Pages/Profile/SimplePage/SimplePage";
import Settings from "../pages/Pages/Profile/Settings/Settings";
import Team from "../pages/Pages/Team/Team";
import Timeline from "../pages/Pages/Timeline/Timeline";
import Faqs from "../pages/Pages/Faqs/Faqs";
import Pricing from "../pages/Pages/Pricing/Pricing";
import Gallery from "../pages/Pages/Gallery/Gallery";
import Maintenance from "../pages/Pages/Maintenance/Maintenance";
import ComingSoon from "../pages/Pages/ComingSoon/ComingSoon";
import SiteMap from "../pages/Pages/SiteMap/SiteMap";
import SearchResults from "../pages/Pages/SearchResults/SearchResults";

import CoverPasswReset from "../pages/AuthenticationInner/PasswordReset/CoverPasswReset";
import BasicLockScreen from "../pages/AuthenticationInner/LockScreen/BasicLockScr";
import CoverLockScreen from "../pages/AuthenticationInner/LockScreen/CoverLockScr";
import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";
import BasicSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg";
import CoverSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg";
import BasicTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify";
import CoverTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

//APi Key
import APIKey from "../pages/APIKey/index";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import AdminLogin from "../pages/Authentication/LoginAdmin";

//Charts
import LineCharts from "../pages/Charts/ApexCharts/LineCharts";
import AreaCharts from "../pages/Charts/ApexCharts/AreaCharts";
import ColumnCharts from "../pages/Charts/ApexCharts/ColumnCharts";
import BarCharts from "../pages/Charts/ApexCharts/BarCharts";
import MixedCharts from "../pages/Charts/ApexCharts/MixedCharts";
import TimelineCharts from "../pages/Charts/ApexCharts/TimelineCharts";
import CandlestickChart from "../pages/Charts/ApexCharts/CandlestickChart";
import BoxplotCharts from "../pages/Charts/ApexCharts/BoxplotCharts";
import BubbleChart from "../pages/Charts/ApexCharts/BubbleChart";
import ScatterCharts from "../pages/Charts/ApexCharts/ScatterCharts";
import HeatmapCharts from "../pages/Charts/ApexCharts/HeatmapCharts";
import TreemapCharts from "../pages/Charts/ApexCharts/TreemapCharts";
import PieCharts from "../pages/Charts/ApexCharts/PieCharts";
import RadialbarCharts from "../pages/Charts/ApexCharts/RadialbarCharts";
import RadarCharts from "../pages/Charts/ApexCharts/RadarCharts";
import PolarCharts from "../pages/Charts/ApexCharts/PolarCharts";
import ChartsJs from "../pages/Charts/ChartsJs/index";
import Echarts from "../pages/Charts/ECharts/index";

//Job pages
import Statistics from "../pages/Jobs/Statistics";
import JobList from "../pages/Jobs/JobList/List";
import JobGrid from "../pages/Jobs/JobList/Grid";
import JobOverview from "../pages/Jobs/JobList/Overview";
import CandidateList from "../pages/Jobs/CandidateList/ListView";
import CandidateGrid from "../pages/Jobs/CandidateList/GridView";
import NewJobs from "../pages/Jobs/NewJob";
import JobCategories from "../pages/Jobs/JobCategories";
import Application from "../pages/Jobs/Application";
import CompaniesList from "../pages/Jobs/CompaniesList";

// Landing Index
import OnePage from "../pages/Landing/OnePage";
import NFTLanding from "../pages/Landing/NFTLanding";

import PrivecyPolicy from "../pages/Pages/PrivacyPolicy";
import TermsCondition from "../pages/Pages/TermsCondition";
import JobLanding from "../pages/Landing/Job";

// User Profile
// HR Round 5 / Issue 8: user-profile.js (template stub) no longer routed —
// /profile now redirects to the canonical /profile/me self-service page.

import FileManager from "../pages/FileManager";
import ToDoList from "../pages/ToDo";
import IT from "../pages/IT";

import { components } from "react-select";

const authProtectedRoutes = [
  { path: "/dashboard-analytics", component: <DashboardAnalytics /> },
  { path: "/dashboard-crm", component: <DashboardCrm /> },
  { path: "/dashboard", component: <Home /> },
  // Round 16: workflows launcher (cards drill-down — see WorkflowsLauncher)
  { path: "/workflows", component: <WorkflowsLauncher /> },
  { path: "/index", component: <DashboardEcommerce /> },
  { path: "/time-and-attendance", component: (
      <RoleProtected requireModule="time.open">
        <DashboardCrypto />
      </RoleProtected>
    ) },
  { path: "/dashboard-projects", component: <DashboardProject /> },
  { path: "/dashboard-nft", component: <DashboardNFT /> },
  { path: "/dashboard-job", component: <DashboardJob /> },
  { path: "/apps-calendar", component: <Calendar /> },
  { path: "/apps-ecommerce-products", component: <EcommerceProducts /> },
  {
    path: "/apps-ecommerce-product-details/:_id",
    component: <EcommerceProductDetail />,
  },

  {
    path: "/apps-ecommerce-product-details",
    component: <EcommerceProductDetail />,
  },
  { path: "/apps-ecommerce-add-product", component: <EcommerceAddProduct /> },
  { path: "/apps-ecommerce-orders", component: <EcommerceOrders /> },
  {
    path: "/apps-ecommerce-order-details",
    component: <EcommerceOrderDetail />,
  },
  { path: "/apps-ecommerce-customers", component: <EcommerceCustomers /> },
  { path: "/apps-ecommerce-cart", component: <EcommerceCart /> },
  { path: "/apps-ecommerce-checkout", component: <EcommerceCheckout /> },
  { path: "/apps-ecommerce-sellers", component: <EcommerceSellers /> },
  {
    path: "/apps-ecommerce-seller-details",
    component: <EcommerceSellerDetail />,
  },

  { path: "/apps-file-manager", component: <FileManager /> },
  { path: "/apps-todo", component: <ToDoList /> },

  // ── Department dashboards — gated to match the menu visibility ────────────
  // Direct URL access by an unauthorized user redirects to /access-denied.
  // Frontend menu also hides these. Backend controllers are also gated.
    // Perflexion (owner request, 2026-07): engineering part-formula tool —
  // coming-soon page for now, same pattern as Accounting. Open to all
  // authenticated users (informational page, no data).
  { path: "/perflexion", component: <Perflexion /> },
    {
    path: "/accounting",
    component: (
      <RoleProtected requireModule="dept.accounting">
        <Accounting />
      </RoleProtected>
    ),
  },
    {
    path: "/engineering",
    component: (
      <RoleProtected requireModule="dept.engineering">
        <Engineering />
      </RoleProtected>
    ),
  },
  {
    path: "/humanresource",
    component: (
      <RoleProtected requireHr>
        <HumanResource />
      </RoleProtected>
    ),
  },
    {
    path: "/planning",
    component: (
      <RoleProtected requireModule="dept.planning">
        <Planning />
      </RoleProtected>
    ),
  },
    {
    path: "/production",
    component: (
      <RoleProtected requireModule="dept.production">
        <Production />
      </RoleProtected>
    ),
  },
  {
    path: "/it",
    component: (
      <RoleProtected requireModule="dept.it">
        <InfoTechnology />
      </RoleProtected>
    ),
  },
    {
    path: "/quality",
    component: (
      <RoleProtected requireModule="dept.quality">
        <Quality />
      </RoleProtected>
    ),
  },
    {
    path: "/shukla",
    component: (
      <RoleProtected requireModule="dept.shukla">
        <Shukla />
      </RoleProtected>
    ),
  },
    {
    path: "/shipping",
    component: (
      <RoleProtected requireModule="dept.shipping">
        <Shipping />
      </RoleProtected>
    ),
  },
    {
    path: "/sales",
    component: (
      <RoleProtected requireModule="dept.sales">
        <Sales />
      </RoleProtected>
    ),
  },
  {
    path: "/supervisor",
    component: (
      <RoleProtected requireModule="dept.supervisor">
        <Supervisor />
      </RoleProtected>
    ),
  },
  {
    path: "/kpi",
    component: (
      <KpiHubRouteGuard>
        <KPI />
      </KpiHubRouteGuard>
    ),
  },
  {
    // Round 3: X-Ray finance report. Round 6: gate honors finance role OR a
    // granted KPI finance permission (mirrors backend CanAccessFinanceReports).
    path: "/kpi/xray",
    component: (
      <XRayRouteGuard>
        <XRayReport />
      </XRayRouteGuard>
    ),
  },
  {
    // Round 11: On-Time Delivery reports (Planning). One route serves both
    // summary-otd and blown-up via the :reportKey param.
    path: "/kpi/otd/:reportKey",
    component: (
      <PlanningRouteGuard>
        <OtdReport />
      </PlanningRouteGuard>
    ),
  },
  // HR/IT admin subpages — IT Admin only (these manage the system itself).
  {
    path: "/hr/departments",
    component: (
      <RoleProtected requireModule="admin.departments">
        <ManageDepartments />
      </RoleProtected>
    ),
  },
  {
    path: "/hr/roles",
    component: (
      <RoleProtected requireModule="admin.manageRoles">
        <ManageRoles />
      </RoleProtected>
    ),
  },

  // ── IT Admin ────────────────────────────────────────────────────────────
  // Backend also enforces [Authorize(Roles = "IT Admin")] on /api/admin/*,
  // so even bypassing this guard yields 403 from the API.

  // Round 20 (2026): /admin landing — shows the three admin tools as
  // cards. Sidebar's "IT Admin → Admin" link points here.
  {
    path: "/admin",
    component: (
      <RoleProtected requireModule="admin.hub">
        <AdminHub />
      </RoleProtected>
    ),
  },
  // Batch A (Rounds 3 & 4, 2026): consolidated Access Management page —
  // Roles + Role Permissions tabs (Employee Role Assignment, Direct User
  // Permissions, and Effective Access Preview tabs arrive in Batch B). The
  // existing standalone admin pages remain available and untouched. Backend
  // endpoints under /api/Role and /api/admin/access/* are also
  // [Authorize(Roles = "IT Admin")], so bypassing this guard still yields 403.
  {
    path: "/admin/access",
    component: (
      <RoleProtected requireModule="admin.access">
        <AccessManagement />
      </RoleProtected>
    ),
  },
  {
    path: "/admin/employee-roles",
    component: (
      <RoleProtected requireModule="admin.employeeRoles">
        <EmployeeRoleAssignment />
      </RoleProtected>
    ),
  },
  // Phase 1.6: per-user EPO approval limit assignment. Same IT Admin gate
  // as employee-roles above; the backend endpoints under /api/admin/employees-with-epo-limits
  // are also [Authorize(Roles = "IT Admin")] so bypassing the FE guard
  // still yields 403.
  {
    path: "/admin/employee-epo-limits",
    component: (
      <RoleProtected requireModule="admin.epoLimits">
        <EmployeeEpoLimitAssignment />
      </RoleProtected>
    ),
  },
  // Round 19 (2026): per-user permission grants (granular IT-Admin tool).
  // Backend endpoints under /api/admin/user-permissions/* are also
  // [Authorize(Roles = "IT Admin")] so bypassing this guard still yields 403.
  {
    path: "/admin/user-permissions",
    component: (
      <RoleProtected requireModule="admin.userPermissions">
        <UserPermissionsPage />
      </RoleProtected>
    ),
  },

  // Phase 2.3b — DMS inbox pages. My Training is genuinely separate from
  // the document list (it's training acknowledgements, not a doc status
  // filter).
  //
  // Round R1 (2026) — restored the two dedicated inbox pages that legacy
  // had as separate menu items under "Document Management System":
  //   • "Documents Awaiting my Approval"  → /dms/my-pending-approvals
  //   • "Documents Ready for Release"     → /dms/awaiting-release (gated)
  //
  // These DO overlap with AllDms.js filter chips, but the dedicated pages
  // have action affordances the chip filter doesn't (per-row Release in
  // the release inbox; later: per-row Approve/Deny in the approvals
  // inbox once the manager action bar lands in Round 4). Both pages are
  // kept in sync with the chip filter — same backend endpoints, same
  // data shape, just a focused UI.
  //
  // The dms.release module gate (in EffectiveAccessService) already
  // resolves to: HasPerm("Documents Ready for Release") OR RoleId=8
  // (DMS Manager / Operations) OR RoleId=4 (IT Admin). No new perms
  // were added.
  { path: "/dms/my-training", component: (
      <RoleProtected requireModule="training.open">
        <MyTraining />
      </RoleProtected>
    ) },
  { path: "/dms/my-pending-approvals", component: (
      <RoleProtected requireModule="dms.myApprovals">
        <MyPendingApprovals />
      </RoleProtected>
    ) },
  {
    path: "/dms/awaiting-release",
    component: (
      <RoleProtected requireModule="dms.release">
        <AwaitingRelease />
      </RoleProtected>
    ),
  },
  // Round R12 (2026) — Drafts inbox + email-link action handler.
  // /dms/my-drafts: lists Status=60 docs authored by current user (Q11).
  // /dms/action/:token: lands the one-click approve/deny links from emails
  //   (replaces legacy /ApproveDMS/:token at sswhite.systems:8080).
  { path: "/dms/my-drafts", component: (
      <RoleProtected requireModule="dms.myDrafts">
        <MyDrafts />
      </RoleProtected>
    ) },
  { path: "/dms/action/:token", component: <TokenAction /> },

  { path: "/access-denied", component: <AccessDenied /> },

  //Display board
  // Phase 3: integrated apps are now gated behind RoleProtected so direct
  // URL access by an unauthenticated/unauthorized user redirects to
  // /access-denied. Backend authorization policies (CanAccessDigitalInspection,
  // CanAccessMafia, CanAccessDisplayBoard) also enforce 403 on the API.
  // The `requireModule` gate reads the bundle's modules map which is
  // resolved server-side from permissions + country + role — so future
  // restrictions only need a server change, no JS edits.
  {
    path: "/di",
    component: (
      <RoleProtected requireModule="app.di">
        <DI />
      </RoleProtected>
    ),
  },

  // Batch 3 / Round 15 — DI Simulator route (legacy Simselect / "-j"
  // engineer mode). Same app.di gate as /di; the screen itself is
  // read-only, so no write is possible from it.
  {
    path: "/di/simulator",
    component: (
      <RoleProtected requireModule="app.di">
        <DISimulator />
      </RoleProtected>
    ),
  },

  // Round DI-2 — DI Change Log (formerly "Audit Log"). PERMISSION-driven:
  // the "DI - Change Log" permission (gate di.changeLog) — grantable to the
  // quality-engineer role or specific people in Access Management; IT Admin
  // passes via the gate's fallback. The API (GET /Inspection/audit-log)
  // re-enforces the same permission and the job/PO scoping.
  {
    path: "/di/audit",
    component: (
      <RoleProtected requireModule="di.changeLog">
        <DIAuditLog />
      </RoleProtected>
    ),
  },

  {
    path: "/mafia",
    component: (
      <RoleProtected requireModule="app.mafia">
        <Mafia />
      </RoleProtected>
    ),
  },

  {
    path: "/display-boards",
    component: (
      <RoleProtected requireModule="app.displayboard">
        <DisplayBoards />
      </RoleProtected>
    ),
  },

  // Support module (Freshdesk). Visible to every authenticated user — the
  // "support" module gate (EffectiveAccessService.cs) is open because every
  // user can create and view THEIR OWN tickets. All-ticket vs requester-only
  // scope is enforced server-side in FreshdeskController from the
  // "Support Agent" perm / IT-Admin claim. Backend [Authorize] returns
  // 401/403 to anyone who bypasses this wrapper.
  {
    path: "/support",
    component: (
      <RoleProtected requireModule="support">
        <Support />
      </RoleProtected>
    ),
  },
  { path: "/review/exempted/:reviewId", component: <UnifiedReviewPage /> },

  { path: "/epo", component: (
      <RoleProtected requireModule="epo.create">
        <EPO />
      </RoleProtected>
    ) },
  { path: "/epo/:epoNumber/timeline", component: <EpoApprovalsTimeLine /> },

  // Phase 3 Pass 2 — additional EPO manager-menu screens.
  // Module keys (epo.mpc, epo.notReadyForPayment, epo.findByNumber)
  // are defined in EffectiveAccessService.cs. The bundle's modules
  // map is the source of truth — these RoleProtected wrappers just
  // ask the bundle "is this module visible for me?".
  {
    path: "/epo/mpc-viewer",
    component: (
      <RoleProtected requireModule="epo.mpc">
        <MpcEpoViewer />
      </RoleProtected>
    ),
  },
  // R30 — Accounting EPO Viewer. Same component, same data, different
  // title + gate. Mirrors legacy epoViewAllOfMy.vb (isAccounting
  // flag path).
  {
    path: "/epo/accounting-viewer",
    component: (
      <RoleProtected requireModule="epo.accounting">
        <MpcEpoViewer
          title="Accounting EPO Viewer"
          subtitle="Last 1000 EPOs across the company"
        />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/not-ready-for-payment",
    component: (
      <RoleProtected requireModule="epo.notReady">
        <EposNotReadyForPayment />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/find",
    component: (
      <RoleProtected requireModule="epo.findByNumber">
        <FindEpoByNumber />
      </RoleProtected>
    ),
  },
  // Batch 3 / Round 7 — line-item search (find an EPO by item description).
  {
    path: "/epo/find-by-item",
    component: (
      <RoleProtected requireModule="epo.lineSearch">
        <EpoLineSearch />
      </RoleProtected>
    ),
  },
  // Batch 3 / Round 8 — No-EPO / Missing-EPO shipment tracker.
  {
    path: "/epo/missing-epo",
    component: (
      <RoleProtected requireModule="epo.missingEpo">
        <MissingEpoDashboard />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/subordinates",
    component: (
      <RoleProtected requireManager>
        <SubordinateEpos />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/ready-for-payment",
    component: (
      <RoleProtected requireModule="epo.readyPay">
        <EposReadyForPayment />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/shipping",
    component: (
      <RoleProtected requireModule="epo.receive">
        <EposShipping />
      </RoleProtected>
    ),
  },
  // R16 — receive details for a specific EPO (per-line receive/reopen actions).
  {
    path: "/epo/:epoNumber/receive",
    component: (
      <RoleProtected requireModule="epo.receive">
        <EposReceive />
      </RoleProtected>
    ),
  },
  // R19 — partial-payments per EPO (Finance/Babu/IT-Admin only).
  // isBabu already encompasses isFinance + isItAdmin in EffectiveAccessService,
  // so a single flag covers all three intended roles.
  {
    path: "/epo/:epoNumber/partial-payments",
    component: (
      <RoleProtected requireFlag="isBabu">
        <EpoPartialPayments />
      </RoleProtected>
    ),
  },
  { path: "/epo/awaiting-my-approval", component: (
      <RoleProtected requireModule="epo.myApprovals">
        <EpoApprovalsInbox />
      </RoleProtected>
    ) },

  // Phase 3 Pass 2 — Project Approval manager screens.
  {
    path: "/projects/my-department",
    component: (
      <RoleProtected requireModule="projects.deptProjects">
        <DeptProjects />
      </RoleProtected>
    ),
  },
  {
    path: "/projects/awaiting-approval",
    component: (
      <RoleProtected requireModule="projects.awaiting">
        <ProjectsAwaitingApproval />
      </RoleProtected>
    ),
  },

  // ─── Phase 3 Pass 3 — FTO/COA manager+HR + schedules ──────────────────
  // (existing /attendance/fto, /attendance/coa, etc. routes are untouched
  //  and continue to serve the unified Personal Attendance index page.)
  {
    path: "/attendance/dept/fto",
    // Batch 5 (G-18): added Manager + President + President-CEO to the
    // gate. Was hr.fto-only; legacy showed DeptFtos to managers too.
    // IT Admin bypass is automatic in RoleProtected.
    component: (<RoleProtected requireModule="attendance.deptFto"><DeptFtos /></RoleProtected>),
  },
  {
    path: "/attendance/dept/coa",
    // Batch 5 (G-18): same as DeptFtos — added Manager visibility.
    component: (<RoleProtected requireModule="attendance.deptCoa"><DeptCoas /></RoleProtected>),
  },
  {
    path: "/attendance/ytd",
    // Batch 5 (G-17): YTD FTO Status is no longer HR-only. Backend
    // /api/fto/ytd scopes the response (self / manager subtree / HR
    // dept-wide) so the FE gate just needs the user to be authenticated —
    // AuthProtected already enforces that one level up.
    component: (<RoleProtected requireModule="attendance.ytdFto"><YtdFtoReport /></RoleProtected>),
  },
  {
    // P8 / G-37: "My FTO Balance" — per-employee balance summary card.
    // Mirrors the legacy frmFtoViewYTD form. EmpID comes from JWT (the
    // page only ever shows the caller's own balances).
    path: "/attendance/my-balance",
    component: (<RoleProtected requireModule="attendance.myBalance"><MyFtoBalance /></RoleProtected>),
  },
  {
    // Batch 3 (G-15 FE): EmpReactivate page — HR/IT only. Mirrors the
    // legacy EmpReactivate.Designer.vb form. Backend was shipped in
    // Batch 7 (/api/registration/inactive-employees + /reactivate).
    path: "/hr/reactivate",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=employees&view=reactivate" replace /></RoleProtected>),
  },
  {
    // Phase 3 / Feature 2: HR landing dashboard — HR/IT only.
    path: "/hr/dashboard",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><HrDashboard /></RoleProtected>),
  },
  {
    // Phase 3 / Feature 3: Employee self-service profile — any authenticated user.
    // AuthProtected at the Layout level already enforces sign-in.
    path: "/profile/me",
    component: (<MyProfile />),
  },
  {
    // Phase 3 / Feature 3: HR queue for profile-update approvals.
    path: "/hr/profile-approvals",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=review&view=profiles" replace /></RoleProtected>),
  },
  {
    // Phase 3 / Feature 4: HR Audit Trail.
    path: "/hr/audit",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=more&item=audit" replace /></RoleProtected>),
  },
  {
    // Batch P4: Year-End FTO admin (HR/IT only).
    // Frontend for the /api/fto/year-end/preview + /commit endpoints
    // shipped in Batch 5b.
    path: "/hr/fto-year-end",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=fto&item=year-end" replace /></RoleProtected>),
  },
  {
    // Batch P4: Add Paid FTO admin (HR/IT only).
    // Frontend for the /api/fto/consumed/add + list endpoints shipped
    // in Batch 5b.
    path: "/hr/paid-fto",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=fto&item=record-paid" replace /></RoleProtected>),
  },
  {
    // Phase 2 / G-31 — FTO HR Summary (per-emp snapshot grid).
    path: "/hr/fto-summary",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=fto&item=summary" replace /></RoleProtected>),
  },
  {
    // Phase 2 / G-32 — Compensation Days editor.
    path: "/hr/comp-days",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=fto&item=comp-days" replace /></RoleProtected>),
  },
  {
    // Phase 2 / G-33 — FTO Holiday editor.
    path: "/hr/holidays",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=fto&item=holidays" replace /></RoleProtected>),
  },
  {
    // Phase 2 / G-34 — Year-end request view (53-week per-emp audit).
    path: "/hr/year-end-request",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=fto&item=year-end-request" replace /></RoleProtected>),
  },
  {
    // HR Round 1 / Issue 2 — Unified HR Review Dashboard. One queue for all
    // pending FTO / COA / Profile / missing-punch items. Backend endpoint
    // (/api/dashboard/hr/review-queue) is CanAccessHR-gated, so direct URL
    // access without HR rights fails server-side too.
    path: "/hr/review",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=review" replace /></RoleProtected>),
  },
  {
    // HR Round 1 / Issue 3 — COA Central (COA counterpart to FTO Central).
    // Backend endpoint (/api/coa/central) is CanAccessHR-gated.
    path: "/hr/coa-central",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=coa" replace /></RoleProtected>),
  },
  {
    // HR Round 2 / Issue 6 — Late-In Review dashboard + email workflow.
    // Backend (/api/hr/late-in/*) is CanAccessHR-gated, so direct URL/API
    // access without HR rights fails server-side too.
    path: "/hr/late-in",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=review&view=latein" replace /></RoleProtected>),
  },
  {
    // HR Round 3 / Issue 5 — database-generated attendance report
    // (master-sheet grid + monthly counts). Backend CanAccessHR-gated.
    path: "/hr/attendance-report",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=reports&report=attendance" replace /></RoleProtected>),
  },
  {
    // HR Round 3 / Issue 5 — late-in summaries by employee/dept/supervisor.
    path: "/hr/late-in-report",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=review&view=latein&sub=summary" replace /></RoleProtected>),
  },
  {
    path: "/hr/attendance-analytics",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=reports&report=analytics" replace /></RoleProtected>),
  },
  {
    // Round 18 — payroll time card (legacy Time Card Report + automatic
    // paid/unpaid FTO, COA top-up, holiday credits). Backend CanAccessHR-gated.
    path: "/hr/payroll-timecard",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=reports&report=payroll" replace /></RoleProtected>),
  },
  {
    // Round 21 — HR enters a Paid OR Unpaid FTO for an employee (the direct
    // "give unpaid FTO" path). Backend CanAccessHR-gated (api/fto/hr-add).
    path: "/hr/add-fto",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=fto&item=add-fto" replace /></RoleProtected>),
  },
  {
    // Round 22 — combined FTO+COA history (approved/denied/pending) with HR
    // void. Backend CanAccessHR-gated (Reports/leave-archive + hr-void).
    path: "/hr/leave-archive",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=history" replace /></RoleProtected>),
  },
  {
    // Round 23 (simplification) — the HR command center: person search,
    // today strip, four task doors. Composes existing gated endpoints only.
    path: "/hr/home",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource" replace /></RoleProtected>),
  },
  {
    // Round 23 (simplification) — ONE wizard for paid/unpaid FTO, COA, and
    // payouts; routes to the existing hr-add / consumed endpoints.
    path: "/hr/record",
    component: (<RoleProtected requireAny={["HR Admin","IT Admin"]}><Navigate to="/humanresource?section=leave&area=record" replace /></RoleProtected>),
  },
  {
    path: "/attendance/fto/schedule",
    component: (<RoleProtected requireModule="attendance.myFtoSched"><FtoSchedule /></RoleProtected>),    // everyone sees their own
  },
  {
    path: "/attendance/coa/schedule",
    component: (<RoleProtected requireModule="attendance.myCoaSched"><CoaSchedule /></RoleProtected>),    // everyone sees their own
  },

  // ─── Phase 3 Pass 3 — Task Management manager screens ─────────────────
  {
    path: "/task-management/dept",
    component: (<RoleProtected requireModule="task.deptTasks"><DeptTasks /></RoleProtected>),
  },
  {
    path: "/task-management/by-date",
    component: (<RoleProtected requireModule="task.byDate"><TaskReportingByDate /></RoleProtected>),
  },
  {
    path: "/task-management/assigned",
    component: <TasksIveAssigned />,    // every user sees their own
  },
  {
    // Round TM-7 (2026) — legacy Spot Check (direct reports only).
    path: "/task-management/activity",
    component: (<RoleProtected requireModule="task.deptTasks"><CurrentDeptActivity /></RoleProtected>),
  },
  {
    // Round TM-9 (2026) — every employee reviews their OWN day.
    path: "/task-management/eod",
    component: <EndOfDay />,
  },
  {
    // Round TM-13 (2026) — Task Auditor permission (replaces legacy
    // hardcoded 2726/2706; IT Admin passes via the module map).
    path: "/task-management/auditor",
    component: (<RoleProtected requireModule="task.auditor"><TaskAuditor /></RoleProtected>),
  },

  // ─── Phase 3 Pass 3 — Travel Expense Approval ─────────────────────────
  {
    path: "/travel-expense",
    component: (<RoleProtected requireModule="travel.mine"><TravelExpenseIndex /></RoleProtected>),  // tabs adapt to manager status
  },
  // Create-new-request form (legacy frmTravelExpense.vb).
  // Must come BEFORE /travel-expense/:id so "new" isn't captured as an id.
  {
    path: "/travel-expense/new",
    component: (<RoleProtected requireModule="travel.new"><TravelExpenseForm /></RoleProtected>),
  },
  {
    path: "/travel-expense/:id/edit",
    component: <TravelExpenseForm />,
  },
  {
    path: "/travel-expense/:id",
    component: <TravelExpenseDetail />,
  },

  // ─── Merged from development branch ────────────────────────────────────
  // Time & Attendance employee tools. Punch history & "Who's In Building"
  // are personal/department views — anyone authenticated can see them;
  // backend filters scope. Combined SchedulePage replaces splitting between
  // FtoSchedule and CoaSchedule (both keep working, this is the unified one).
  { path: "/time-and-attendance/punch-record", component: <PunchRecord /> },
  { path: "/time-and-attendance/whos-in-building", component: <WhosInBuilding /> },
  { path: "/attendance/schedule", component: <SchedulePage /> },

  // Expected Visitors register — front desk / receptionist use. Backend
  // (ExpectedVisitorsController) is currently [ApiController] without an
  // explicit policy; if you want to restrict this to receptionists only,
  // add a RoleProtected wrapper here and a policy on the controller.
  { path: "/visitors", component: <ExpectedVisitors /> },

  // SN-PO Awaiting FL Approval — MPC/SuperUser/ItAdmin only. The page itself
  // also gates with useAuth().isMPC etc. so a direct URL hit shows a polite
  // "restricted" message instead of a blank page.
  { path: "/epo/sn-awaiting-fl-approval", component: (
      <RoleProtected requireModule="epo.snApprovals">
        <SnEpoAwaitingFlApproval />
      </RoleProtected>
    ) },

  // Contract Review (Pass 3 + Pass 4)
  { path: "/contract-review", component: (
      <RoleProtected requireModule="cr.open">
        <ContractReview />
      </RoleProtected>
    ) },
  { path: "/contract-review/new", component: <ContractReviewForm /> },
  { path: "/contract-review/:id", component: <ContractReviewForm /> },
  { path: "/organizational-chart", component: (
      <RoleProtected requireModule="orgchart.open">
        <OrgChart />
      </RoleProtected>
    ) },
  // Round DMS-UAT-1 (2026) — Issue 1: the dashboard "Open Tasks" card links
  // here, but the page only ever shows the CALLER'S OWN tasks (the my-tasks
  // tabs). Gating a personal view behind "Task Management - Open" produced
  // the "Access Denied" the user reported while the card still showed their
  // task count. The tasks.open module gate was broader than required, so it
  // is removed from the personal index only. The manager screens below
  // (/task-management/dept, /task-management/by-date) keep their gates, and
  // the backend my-tasks endpoint now enforces caller identity server-side
  // (see TaskManagementController.GetMyTasks) — a direct URL or forged
  // ?empId= still cannot read anyone else's tasks.
  { path: "/task-management", component: <TaskManagement /> },
  {
    path: "/task-management/create",
    component: <CreateTask />,
  },
  {
    path: "/task-management/view-task/:taskId",
    component: <TaskDetail />,
  },

  //DI and //Mafia Routes
  // (Routes already declared above under "Display board" — second
  // declaration removed to prevent React Router duplicate-path warnings.)

  // Index — navbar points here
  { path: "/attendance", component: (
      <RoleProtected requireModule="attendance.mine">
        <AttendanceIndex />
      </RoleProtected>
    ) },

  // FTO form — new & edit
  { path: "/attendance/fto/new", component: (
      <RoleProtected requireModule="attendance.newFto">
        <FtoRequestPage />
      </RoleProtected>
    ) },
  // Shared FTO/COA approvals workspace (supervisor + HR). Must precede /:id.
  { path: "/attendance/approvals", component: <ApprovalsPage /> },
  { path: "/attendance/fto/:id", component: <FtoRequestPage /> },

  // COA form — new & edit
  { path: "/attendance/coa/new", component: (
      <RoleProtected requireModule="attendance.newCoa">
        <FtoRequestPage />
      </RoleProtected>
    ) },
  { path: "/attendance/coa/:id", component: <FtoRequestPage /> },

  //DMS
  { path: "/document-management", component: (
      <RoleProtected requireModule="dms.all">
        <DocumentManagementSystem />
      </RoleProtected>
    ) },
  { path: "/document-management/all-documents", component: <AllDocuments /> },
  { path: "/document-management/data", component: <Data /> },
  {
    path: "/dms/create/:docType",
    component: <CreateEcn />,
  },
  {
    path: "/dms/edit/:docType/:id",
    component: <CreateEcn />,
  },
  // ✅ Email approval routes — no login required

  //Chat
  { path: "/apps-chat", component: <Chat /> },

  //EMail
  { path: "/apps-mailbox", component: <MailInbox /> },
  { path: "/apps-email-basic", component: <BasicAction /> },
  { path: "/apps-email-ecommerce", component: <EcommerceAction /> },

  //Projects
  { path: "/apps-projects-list", component: <ProjectList /> },
  { path: "/apps-projects-overview", component: <ProjectOverview /> },
  { path: "/apps-projects-create", component: <CreateProject /> },

  // Round TM-14 (2026) — audit L-7: the Velzon demo task routes
  // (/apps-tasks-list-view, /apps-tasks-details) are removed; they showed
  // template fake data at guessable URLs alongside the real module.

  //Api Key
  { path: "/apps-api-key", component: <APIKey /> },

  //Crm
  { path: "/apps-crm-contacts", component: <CrmContacts /> },
  { path: "/apps-crm-companies", component: <CrmCompanies /> },
  { path: "/apps-crm-deals", component: <CrmDeals /> },
  { path: "/apps-crm-leads", component: <CrmLeads /> },

  //Invoices
  { path: "/apps-invoices-list", component: <InvoiceList /> },
  { path: "/apps-invoices-details", component: <InvoiceDetails /> },
  { path: "/apps-invoices-create", component: <InvoiceCreate /> },

  //Supports Tickets
  { path: "/apps-tickets-list", component: <ListView /> },
  { path: "/apps-tickets-details", component: <TicketsDetails /> },

  //transactions
  { path: "/apps-crypto-transactions", component: <Transactions /> },
  { path: "/apps-crypto-buy-sell", component: <BuySell /> },
  { path: "/apps-crypto-orders", component: <CryproOrder /> },
  { path: "/apps-crypto-wallet", component: <MyWallet /> },
  { path: "/apps-crypto-ico", component: <ICOList /> },
  { path: "/apps-crypto-kyc", component: <KYCVerification /> },

  // NFT Marketplace
  { path: "/apps-nft-marketplace", component: <Marketplace /> },
  { path: "/apps-nft-collections", component: <Collections /> },
  { path: "/apps-nft-create", component: <CreateNFT /> },
  { path: "/apps-nft-creators", component: <Creators /> },
  { path: "/apps-nft-explore", component: <ExploreNow /> },
  { path: "/apps-nft-item-details", component: <ItemDetails /> },
  { path: "/apps-nft-auction", component: <LiveAuction /> },
  { path: "/apps-nft-ranking", component: <Ranking /> },
  { path: "/apps-nft-wallet", component: <WalletConnect /> },

  //charts
  { path: "/charts-apex-line", component: <LineCharts /> },
  { path: "/charts-apex-area", component: <AreaCharts /> },
  { path: "/charts-apex-column", component: <ColumnCharts /> },
  { path: "/charts-apex-bar", component: <BarCharts /> },
  { path: "/charts-apex-mixed", component: <MixedCharts /> },
  { path: "/charts-apex-timeline", component: <TimelineCharts /> },
  { path: "/charts-apex-candlestick", component: <CandlestickChart /> },
  { path: "/charts-apex-boxplot", component: <BoxplotCharts /> },
  { path: "/charts-apex-bubble", component: <BubbleChart /> },
  { path: "/charts-apex-scatter", component: <ScatterCharts /> },
  { path: "/charts-apex-heatmap", component: <HeatmapCharts /> },
  { path: "/charts-apex-treemap", component: <TreemapCharts /> },
  { path: "/charts-apex-pie", component: <PieCharts /> },
  { path: "/charts-apex-radialbar", component: <RadialbarCharts /> },
  { path: "/charts-apex-radar", component: <RadarCharts /> },
  { path: "/charts-apex-polar", component: <PolarCharts /> },

  { path: "/charts-chartjs", component: <ChartsJs /> },
  { path: "/charts-echarts", component: <Echarts /> },

  // Base Ui
  { path: "/ui-alerts", component: <UiAlerts /> },
  { path: "/ui-badges", component: <UiBadges /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdowns /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-tabs", component: <UiTabs /> },
  { path: "/ui-accordions", component: <UiAccordions /> },
  { path: "/ui-modals", component: <UiModals /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-progress", component: <UiProgress /> },
  { path: "/ui-notifications", component: <UiNotifications /> },
  { path: "/ui-media", component: <UiMediaobject /> },
  { path: "/ui-embed-video", component: <UiEmbedVideo /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-lists", component: <UiList /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-ribbons", component: <UiRibbons /> },
  { path: "/ui-utilities", component: <UiUtilities /> },

  // Advance Ui
  { path: "/advance-ui-nestable", component: <UiNestableList /> },
  { path: "/advance-ui-scrollbar", component: <UiScrollbar /> },
  { path: "/advance-ui-animation", component: <UiAnimation /> },
  { path: "/advance-ui-tour", component: <UiTour /> },
  { path: "/advance-ui-swiper", component: <UiSwiperSlider /> },
  { path: "/advance-ui-ratings", component: <UiRatings /> },
  { path: "/advance-ui-highlight", component: <UiHighlight /> },

  // Widgets
  { path: "/widgets", component: <Widgets /> },

  // Forms
  { path: "/forms-elements", component: <BasicElements /> },
  { path: "/forms-select", component: <FormSelect /> },
  { path: "/forms-editors", component: <FormEditor /> },
  { path: "/forms-checkboxes-radios", component: <CheckBoxAndRadio /> },
  { path: "/forms-masks", component: <Masks /> },
  { path: "/forms-file-uploads", component: <FileUpload /> },
  { path: "/forms-pickers", component: <FormPickers /> },
  { path: "/forms-range-sliders", component: <FormRangeSlider /> },
  { path: "/forms-layouts", component: <Formlayouts /> },
  { path: "/forms-validation", component: <FormValidation /> },
  { path: "/forms-wizard", component: <FormWizard /> },
  { path: "/forms-advanced", component: <FormAdvanced /> },
  { path: "/forms-select2", component: <Select2 /> },

  //Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-gridjs", component: <GridTables /> },
  { path: "/tables-listjs", component: <ListTables /> },
  { path: "/tables-datatables", component: <DataTables /> },
  { path: "/tables-react", component: <ReactTable /> },

  //Icons
  { path: "/icons-remix", component: <RemixIcons /> },
  { path: "/icons-boxicons", component: <BoxIcons /> },
  { path: "/icons-materialdesign", component: <MaterialDesign /> },
  { path: "/icons-feather", component: <FeatherIcons /> },
  { path: "/icons-lineawesome", component: <LineAwesomeIcons /> },
  { path: "/icons-crypto", component: <CryptoIcons /> },

  //Maps
  { path: "/maps-google", component: <GoogleMaps /> },
  { path: "/maps-vector", component: <VectorMaps /> },
  { path: "/maps-leaflet", component: <LeafletMaps /> },

  //Pages
  { path: "/pages-starter", component: <Starter /> },
  { path: "/pages-profile", component: <SimplePage /> },
  { path: "/pages-profile-settings", component: <Settings /> },
  { path: "/pages-team", component: <Team /> },
  { path: "/pages-timeline", component: <Timeline /> },
  { path: "/pages-faqs", component: <Faqs /> },
  { path: "/pages-gallery", component: <Gallery /> },
  { path: "/pages-pricing", component: <Pricing /> },
  { path: "/pages-sitemap", component: <SiteMap /> },
  { path: "/pages-search-results", component: <SearchResults /> },

  //Job pages
  { path: "/apps-job-statistics", component: <Statistics /> },
  { path: "/apps-job-lists", component: <JobList /> },
  { path: "/apps-job-grid-lists", component: <JobGrid /> },
  { path: "/apps-job-details", component: <JobOverview /> },
  { path: "/apps-job-candidate-lists", component: <CandidateList /> },
  { path: "/who-in-the-building", component: <CandidateGrid /> },
  { path: "/apps-job-application", component: <Application /> },
  { path: "/apps-job-new", component: <NewJobs /> },
  { path: "/apps-job-companies-lists", component: <CompaniesList /> },
  { path: "/apps-job-categories", component: <JobCategories /> },

  { path: "/pages-privacy-policy", component: <PrivecyPolicy /> },
  { path: "/pages-terms-condition", component: <TermsCondition /> },

  //User Profile
  // HR Round 5 / Issue 8 — profile unification. The Velzon template stub
  // (user-profile.js: hardcoded "Admin"/dummy data) is retired; every entry
  // point lands on the real self-service page. The /profile path is KEPT as
  // a redirect so old bookmarks/links keep working.
  { path: "/profile", component: <Navigate to="/profile/me" replace /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  { path: "/loginAdmin", component: <AdminLogin /> },

  //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-signup-basic", component: <BasicSignUp /> },
  { path: "/auth-signup-cover", component: <CoverSignUp /> },
  { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-coming-soon", component: <ComingSoon /> },

  { path: "/landing", component: <OnePage /> },
  { path: "/nft-landing", component: <NFTLanding /> },
  { path: "/job-landing", component: <JobLanding /> },

  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },

  {
    path: "/ApproveDMS/:token",
    component: <ApprovalPage action="approve" />,
    isPublic: true, // remove this if you don't have a public route flag
  },
  {
    path: "/DenyDMS/:token",
    component: <ApprovalPage action="deny" />,
    isPublic: true,
  },
];

export { authProtectedRoutes, publicRoutes };
